export default __webpack_public_path__ + "static/media/logo.2581a614.png";